import React from 'react';

interface MarkdownTableProps {
  markdown: string;
}

const MarkdownTable: React.FC<MarkdownTableProps> = ({ markdown }) => {
  if (!markdown || markdown.trim() === '') {
    return null;
  }

  const parseMarkdownTable = (markdownText: string) => {
    const lines = markdownText.trim().split('\n');
    if (lines.length < 3) return null;

    const headerLine = lines[0];
    const headers = headerLine.split('|').map(cell => cell.trim()).filter(cell => cell !== '');

    const dataLines = lines.slice(2);
    const rows = dataLines.map(line => {
      return line.split('|').map(cell => cell.trim()).filter(cell => cell !== '');
    }).filter(row => row.length > 0);

    return { headers, rows };
  };

  const tableData = parseMarkdownTable(markdown);

  if (!tableData) {
    return (
      <div className="text-gray-500 text-sm">無法解析表格數據</div>
    );
  }

  return (
    <>
      {/* 桌機 / 平板：保留 table 原樣 */}
      <div className="hidden md:block overflow-x-auto">
        <table className="min-w-full border-collapse border border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              {tableData.headers.map((header, index) => (
                <th
                  key={index}
                  className="border border-gray-200 px-3 py-2 text-left text-xs font-medium text-gray-600"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.rows.map((row, rowIndex) => (
              <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                {row.map((cell, cellIndex) => (
                  <td
                    key={cellIndex}
                    className="border border-gray-200 px-3 py-2 text-xs text-gray-600"
                    dangerouslySetInnerHTML={{ __html: cell }}
                  ></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 手機：每筆 row 改卡片式排列，每個 cell 標上對應 header */}
      <div className="md:hidden flex flex-col gap-3">
        {tableData.rows.map((row, rowIndex) => (
          <div
            key={rowIndex}
            className="border border-gray-200 rounded-lg overflow-hidden bg-white"
          >
            {row.map((cell, cellIndex) => {
              const header = tableData.headers[cellIndex];
              if (!header) return null;
              return (
                <div
                  key={cellIndex}
                  className="border-b border-gray-100 last:border-b-0"
                >
                  <div className="bg-gray-50 px-3 py-1.5 text-xs font-medium text-gray-600">
                    {header}
                  </div>
                  <div
                    className="px-3 py-2 text-sm text-gray-700"
                    dangerouslySetInnerHTML={{ __html: cell }}
                  />
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </>
  );
};

export default MarkdownTable;
